import microApp from '@micro-zoe/micro-app'

/**
 * 下载文件确认弹窗
 */
export const fileConfirm = () => {
  const microAppGlobalData = microApp.getGlobalData()
  const openDownload = microAppGlobalData?.openDownload;
  console.log(openDownload)
  openDownload?.();
}
/**
 * 上传数据处理
 */
export const formatUploadData = (urls: Array<any>) => {
  return urls.map(item => ({
    url: item.response ? item.response?.data?.fileUrl : item.url,
    name: item.response ? item.response?.data?.originalFilename : item.name,
  }))
}
/**
 * 上传相对路径文件处理
 */
export const formatRelativeUploadData = (urls: Array<any>) => {
  return urls.map(item => ({
    url: item.response ? item.response?.data?.fileUrl : item.url,
    name: item.response ? item.response?.data?.originalFilename : item.name,
    filePath: item.response ? item.response?.data?.filePath : item.filePath,
  }))
}
/**
 * 处理图片路径
 */
export const checkPicturePre = (url?: any) => {
  const SHJ_FILE_URL_PREFIX:string = localStorage.getItem('SHJ_FILE_URL_PREFIX');
  if (url&&!url?.startsWith("http")) {
    return `${JSON.parse(SHJ_FILE_URL_PREFIX)}${url}`;
  }
  return url;
};
